/**
 * Jquery EmojiPicker plugin.
 *
 * This is currently being used for passwords fields when users, espeically students, login
 * using emojis. This will bind to an input field, create a wrapper, and inject emoji picker
 * via comet popover.
 *
 * Configureable Options passed to constructor:
 *  width: '200' (default)
 *  height: '350' (default)
 *  position: 'right'|'left',
 *  fadeTime: 100 (ms. default)
 *  container: 'body' (default)
 *  passwordToggleColor: 'white' (default)
 *
 * Example Usage:
 * <form><input id="myinput" /></form>
 * <script>
 * $(function() {
 *    $('#myinput').emojiPicker({});
 * });
 * </script>
 */

;(function($) {
    "use strict";

    /** @const */
    var PLUGIN_NAME = "emojiPicker";

    /** @const */
    var POSITIONS = ['left', 'right'];

    /** @const */
    var MIN_WIDTH = 280,
        MAX_WIDTH = 600,
        MIN_HEIGHT = 100,
        MAX_HEIGHT = 350,
        MAX_ICON_HEIGHT = 50;

    /** @const */
    var DEFAULTS = {
      "width": '200',
      "height": '180',
      "position": 'right',
      "fadeTime": 100,
      "iconColor": 'black',
      "iconBackgroundColor": '#eee',
      "recentCount": 36,
      "container": 'body',
      "button": true,
      "passwordToggleColor": 'white',
      "hidePasswordToggle": false,
      "additionalClasses": '',
      "emojiContainerClass": '',
    };

    /** @const */
    var EMOJIS = [
        {
            "name": "musical_note",
            "shortcode": "musical_note",
            "unicode": "1F3B5",
            "description": "MUSICAL_NOTE"
        },
        {
            "name": "star",
            "shortcode": "star",
            "unicode": "2B50",
            "description": "STAR"
        },
        {
            "name": "pencil",
            "shortcode": "pencil",
            "unicode": "1f4dd",
            "description": "PENCIL"
        },
        {
            "name": "dog",
            "shortcode": "dog",
            "unicode": "1f436",
            "description": "DOG"
        },
        {
            "name": "fish",
            "shortcode": "fish",
            "unicode": "1F41F",
            "description": "FISH"
        },
        {
            "name": "trophy",
            "shortcode": "trophy",
            "unicode": "1F3C6",
            "description": "TROPHY"
        },
        {
            "name": "guitar",
            "shortcode": "guitar",
            "unicode": "1F3B8",
            "description": "GUITAR"
        },
        {
            "name": "truck",
            "shortcode": "truck",
            "unicode": "1F69A",
            "description": "TRUCK"
        },
        {
            "name": "sailboat",
            "shortcode": "sailboat",
            "unicode": "26F5",
            "description": "SAILBOAT"
        },
        {
            "name": "birthday",
            "shortcode": "birthday",
            "unicode": "1F382",
            "description": "BIRTHDAY"
        },
        {
            "name": "notebook",
            "shortcode": "notebook",
            "unicode": "1F4D3",
            "description": "NOTEBOOK"
        },
        {
            "name": "crayon",
            "shortcode": "crayon",
            "unicode": "1F58D-FE0F",
            "description": "CRAYON"
        },
        {
            "name": "gift",
            "shortcode": "gift",
            "unicode": "1F381",
            "description": "GIFT"
        },
        {
            "name": "apple",
            "shortcode": "apple",
            "unicode": "1F34E",
            "description": "APPLE"
        },
        {
            "name": "shell",
            "shortcode": "shell",
            "unicode": "1F41A",
            "description": "SHELL"
        },
        {
            "name": "basketball",
            "shortcode": "basketball",
            "unicode": "1F3C0",
            "description": "BASKETBALL"
        },
        {
            "name": "butterfly",
            "shortcode": "butterfly",
            "unicode": "1F98B",
            "description": "BUTTERFLY"
        },
        {
            "name": "chocolate_bar",
            "shortcode": "chocolate_bar",
            "unicode": "1F36B",
            "description": "CHOCOLATE_BAR"
        },
        {
            "name": "sunflower",
            "shortcode": "sunflower",
            "unicode": "1F33B",
            "description": "SUNFLOWER"
        },
        {
            "name": "motorcycle",
            "shortcode": "motorcycle",
            "unicode": "1F3CD-FE0F",
            "description": "MOTORCYCLE"
        }
    ];

    /**
     * Emoji Picker
     *
     * @param {domElement} element Target dom element, i.e. input field.
     * @param {object} options Defined option overrides.
     * @constructor
     */
    function EmojiPicker(element, options) {
        this.element = element;
        this.$el = $(element);

        this.emojis = EMOJIS;

        this.settings = $.extend({}, DEFAULTS, options);

        this.$container = $(this.settings.container);

        this.settings.width = parseInt(this.settings.width, 10);
        this.settings.height = parseInt(this.settings.height, 10);

        // validate height and width
        if (this.settings.width >= MAX_WIDTH) {
            this.settings.width = MAX_WIDTH;
        } else if (this.settings.width < MIN_WIDTH) {
            this.settings.width = MIN_WIDTH;
        }
        if (this.settings.height >= MAX_HEIGHT) {
            this.settings.height = MAX_HEIGHT;
        } else if (this.settings.height < MIN_HEIGHT) {
            this.settings.height = MIN_HEIGHT;
        }

        if ($.inArray(this.settings.position, POSITIONS) === -1) {
            this.settings.position = DEFAULTS.position;
        }

        this.init();
    }

    $.extend(EmojiPicker.prototype, {
        /**
         * Initializes EmojiPicker to default state, adds event listeners, and binds to dom elements.
         */
        "init": function() {
            this.active = false;
            if (this.settings.login2021) {
                this.addPickerIconV2();
            } else {
                this.addPickerIcon();
            }
            this.createPicker();
            this.listen();
        },

        /**
         * Adds the picker icon that will trigger emoji picker. If no button was given,
         * we will create a wrapper and append a div/button. If a button was given,
         * this method is skipped.
         */
         "addPickerIcon": function() {
            if (this.settings.button) {
                var elementHeight = this.$el.outerHeight();
                var iconHeight = elementHeight > MAX_ICON_HEIGHT ?
                    MAX_ICON_HEIGHT : elementHeight;

                var objectWidth = this.$el.width();
                var toggleClasses = [
                    'comet-button',
                    'comet-button--flat',
                    'comet-button--toggle-password',
                    this.settings.passwordToggleColor
                ];

                $('.de-form__toggle-password').hide();

                var $pwToggle = $('<button />', {
                    "class": toggleClasses.join(' '),
                    "html": 'show',
                    "style": this.settings.hidePasswordToggle ? 'display: none' : '',
                });

                this.$el.width(objectWidth);

                var $container = $('<div />', {
                    "class": 'emoji-picker-icon-container',
                }),
                $iconContainer = $('<div />', {
                    "class": 'emoji-picker-icon-container--icon',
                });

                this.$wrapper = this.$el
                    .wrap($container)
                    .parent();

                this.$icon = $($iconContainer)
                    .height(iconHeight)
                    .width(iconHeight)
                    .addClass(this.settings.iconColor)
                    .css('backgroundColor', this.settings.iconBackgroundColor);

                this.$wrapper.append($pwToggle);
                this.$wrapper.append(this.$icon);
            }
        },

        "addPickerIconV2": function() {
            if (this.settings.button) {
                var objectWidth = this.$el.width();

                this.$el.width(objectWidth);

                var $container = $('<div />', {
                    "class": this.settings.emojiContainerClass || 'emoji-picker-icon-container', //de-form__emoji-container
                }),
                $iconContainer = $('<button />', {
                    "class": this.settings.emojiContainerIconClass || 'emoji-picker-icon-container--icon ', //de-form__emoji-container--button
                    "html": this.settings.buttonText,
                    "type": 'button',
                });

                this.$wrapper = this.$el
                    .wrap($container)
                    .parent();

                this.$icon = $($iconContainer)
                    .addClass(this.settings.iconColor)
                    .css('backgroundColor', this.settings.iconBackgroundColor);

                this.$wrapper.append(this.$icon);
            }
        },

        /**
         * Builds html picker panel and appends to the container.
         */
        "createPicker": function() {
            // Show template
            this.$picker = getPickerHTML()
                .appendTo(this.$container)
                .width(this.settings.width)
                .height(this.settings.height)
                .css('z-index', 10000);

            // apply section/user specific classes to main picker container.
            if (this.settings.additionalClasses) {
                this.$container.addClass(this.settings.additionalClasses);
            }

            // Picker height
            this.$picker.find('.sections')
                .height(parseInt(this.settings.height, 10));

            // Tab size based on width
            if (this.settings.width < 240) {
                this.$picker
                .find('.emoji')
                .css({
                    "width": '1em',
                    "height": '1em'
                });
            }
        },

        /**
         * Removes listeners and dom nodes when we destroy the picker.
         */
        "destroyPicker": function() {
            this.$picker.unbind('mouseover');
            this.$picker.unbind('mouseout');
            this.$picker.unbind('click');
            this.$picker.remove();

            $.removeData(this.$el.get(0), 'emojiPicker');

            return this;
        },

        /**
         * Adds the following event listeners to picker nodes:
         *  - picker icon - click - opens picker
         *  - emoji - mouseover|mouseout - highlights emoji
         *  - document.body - click - auto close picker when focusing outside open picker
         *  - pick popover - resize - tries to auto resize window within bounds when screensize changes.
         */
        "listen": function() {
            if (this.settings.button) {
                this.$wrapper.find('.emoji-picker-icon-container--icon')
                    .click($.proxy(this.iconClicked, this));
            }

            if (this.settings.emojiContainerIconClass) {
                this.$wrapper.find('.' + this.settings.emojiContainerIconClass)
                    .click($.proxy(this.iconClicked, this));
            }

            this.$picker.on('click', 'em', $.proxy(this.emojiClicked, this));
            this.$picker.click($.proxy(this.pickerClicked, this));
            this.$picker.find('.shortcode').mouseover(function(e) {
                e.stopPropagation();
            });

            $('.comet-button.comet-button--toggle-password')
                .click($.proxy(this.togglePassword, this));

            $(document.body).click($.proxy(this.clickOutside, this));
            $(window).resize($.proxy(this.updatePosition, this));
        },

        /**
        * Click handler for toggling password, i.e. show/hide
        */
       "togglePassword": function(e) {
           e.preventDefault();

           var $target = $(e.target),
               $input = $target.closest('.emoji-picker-icon-container').find('.comet-form__input');

           var isShowing = $input.prop('type') === 'text';

           $input.prop('type', isShowing ? 'password' : 'text');
           $target.html(isShowing ? 'show' : 'hide');
       },

        /**
         * Before picker opens, calculate positioning based on the el or parent and offset to open
         * under icon/button trigger.
         */
        "updatePosition": function() {
            var positionedParent = this.$picker.offsetParent();
            var parentOffset = positionedParent.offset();
            var elOffset = this.$el.offset();

            if (this.settings.position === 'right') {
                elOffset.left += this.$el.outerWidth() - this.settings.width;
            }

            elOffset.top += this.$el.outerHeight();

            var topBase = elOffset.top - parentOffset.top;
            var leftBase = elOffset.left - parentOffset.top;

            if (this.settings.login2021) {
                this.$picker.css({
                    "top": topBase - 90,
                    "left": leftBase + 300
                });
            } else {
                this.$picker.css({
                    "top": topBase - 270,
                    "left": leftBase + 30
                });
            }

            return this;
        },

        /**
         * Hides picker when clicking outside popover, button is clicked, or toggle is triggered.
         */
        "hide": function() {
            $('.comet-popover.comet-popover--bottom')
                .removeClass('visible');

            this.$picker.hide(
                this.settings.fadeTime,
                'linear',
                $.proxy(function() {
                    this.active = false;

                    if (this.settings.onHide) {
                        this.settings.onHide(this.$picker, this.settings, this.active);
                    }
                }, this)
            );
        },

        /**
         * Shows picker when toggle is called or button is clicked.
         */
        "show": function() {
            this.$el.focus();

            $('.comet-popover.comet-popover--bottom')
                .addClass('visible');

            this.updatePosition();

            this.$picker.show(
                this.settings.fadeTime,
                'linear',
                $.proxy(function() {
                    this.active = true;

                    if (this.settings.onShow) {
                        this.settings.onShow(this.$picker, this.settings, this.active);
                    }
                }, this)
            );
        },

        /**
         * Event call back when emoji button is clicked.
         */
        "iconClicked": function() {
            if (this.$picker.is(':hidden')) {
                this.show();

                if (this.$picker.find('.search input').length > 0) {
                    this.$picker.find('.search input').focus();
                }
            } else {
                this.hide();
            }
        },

        /**
         * Event call back when a selected emoji is clicked.
         *
         * @param {object} e click event
         */
        "emojiClicked": function(e) {
            var clickTarget = $(e.target);
            var emojiSpan = clickTarget.is('em') ?
                clickTarget.find('span') : clickTarget.parent().find('.emoji');

            var emojiShortcode = emojiSpan.attr('class').split('emoji-')[1];
            var emojiUnicode = toUnicode(findEmoji(emojiShortcode).unicode);

            insertAtCaret(this.element, emojiUnicode);

            $(this.element).trigger("keyup");

            var event = document.createEvent("HTMLEvents");

            event.initEvent("input", true, true);
            this.element.dispatchEvent(event);
        },

        /**
         * Event call back to prevent propagation when we click a btn.
         *
         * @param {object} e click event
         */
        "pickerClicked": function(e) {
            e.stopPropagation();
        },

        /**
         * Event call back when clicking ourside an active picker. Forces close if active.
         *
         * @param {object} e click event
         */
        "clickOutside": function(e) {
            if (this.active) {
                this.hide();
            }
        },
    });

    /**
     * Register or manipulate $ plugin, i.e. destroy, toggle, or reinit with new options.
     *
     * @param {string} options default option overrides
     */
    $.fn[PLUGIN_NAME] = function (options) {
        if (typeof options === 'string') {
            this.each(function() {
                var plugin = $.data(this, PLUGIN_NAME);

                switch (options) {
                case 'toggle':
                    plugin.iconClicked();
                    break;
                case 'destroy':
                    plugin.destroyPicker();
                    break;
                }
            });

            return this;
        }

        this.each(function() {
        // Don't attach to the same element twice
        if (!$.data(this, PLUGIN_NAME)) {
            $.data(this, PLUGIN_NAME, new EmojiPicker(this, options));
        }
        });

        return this;
    };

    /**
     * Builds picker panel leveraging comet popover.
     */
    function getPickerHTML() {
        var $picker = $('<div />', {
            "class": 'comet-popover--emoji-picker comet-popover comet-popover--bottom',
        });
        var $nub = $('<div />', {
            "class": 'comet-popover__nub',
        });
        var $sections = $('<div />', {
            "class": 'sections',
        });
        var $section = $('<section />', {
            "class": 'comet-popover--emoji-picker__inner'
        });

        // Emoji sections
        $.each(EMOJIS, function(i, emoji) {
            $section.append(
                $('<em />', {
                    "html": '<span class="emoji emoji-' + emoji.shortcode + '">' + toUnicode(emoji.unicode) + '</span>'
                })
            );
        });

        $section.wrap($sections);
        $picker
            .append($nub)
            .append($section);

        return $picker;
    }

    /**
     * Search and return a specific emoji.
     *
     * @param {string} emojiShortcode emoji short code used for look up
     */
    function findEmoji(emojiShortcode) {
        for (var i = 0; i < EMOJIS.length; i++) {
            if (EMOJIS[i].shortcode === emojiShortcode) {
                return EMOJIS[i];
            }
        }
    }

    /**
     * Inserts emoji at a specific input position and then refocuses at position.
     *
     * @param {dom} inputField input node
     * @param {string} myValue existing `inputField` value
     */
    function insertAtCaret(inputField, myValue) {
        if (document.selection) {
            // Internet Explorer
            inputField.focus();

            var sel = document.selection.createRange();

            sel.text = myValue;
            inputField.focus();
        } else if (inputField.selectionStart || inputField.selectionStart === '0') {
            // Firefox and Webkit based
            var startPos = inputField.selectionStart;
            var endPos = inputField.selectionEnd;
            var scrollTop = inputField.scrollTop;

            inputField.value = inputField.value.substring(0, startPos) +
                myValue +
                inputField.value.substring(endPos, inputField.value.length);

            inputField.focus();

            inputField.selectionStart = startPos + myValue.length;
            inputField.selectionEnd = startPos + myValue.length;
            inputField.scrollTop = scrollTop;
        } else {
            inputField.focus();
            inputField.value += myValue;
        }
    }

    /**
     * Convert emoji to unicode.
     *
     * @param {string} code code returned from map to convert emoji to unicode.
     */
    function toUnicode(code) {
        var codes = code.split('-').map(function(value, index) {
            return parseInt(value, 16);
        });

        return String.fromCodePoint.apply(null, codes);
    }

    /**
     * Polyfills
     */
    if (!String.fromCodePoint) {
        String.fromCodePoint = function fromCodePoint() {
            var chars = [], point, offset, units, i;

            for (i = 0; i < arguments.length; ++i) {
                point = arguments[i];
                offset = point - 0x10000;
                units = point > 0xFFFF ?
                    [0xD800 + (offset >> 10), 0xDC00 + (offset & 0x3FF)] : [point];

                chars.push(String.fromCharCode.apply(null, units));
            }

            return chars.join("");
        };
    }

    if (!String.codePointAt) {
        String.codePointAt = function codePointAt(position) {
            if (this === null) {
                return null;
            }

            var string = String(this);
            var size = string.length;

            // `ToInteger`
            var index = position ? Number(position) : 0;

            // Account for out-of-bounds indices:
            if (index < 0 || index >= size) {
                return null;
            }
            // Get the first code unit
            var first = string.charCodeAt(index);
            var second;

            if ( // check if it’s the start of a surrogate pair
                first >= 0xD800 && first <= 0xDBFF && // high surrogate
                size > index + 1 // there is a next code unit
            ) {
                second = string.charCodeAt(index + 1);
                if (second >= 0xDC00 && second <= 0xDFFF) { // low surrogate
                    // https://mathiasbynens.be/notes/javascript-encoding#surrogate-formulae
                    return (first - 0xD800) * 0x400 + second - 0xDC00 + 0x10000;
                }
            }
            return first;
        };
    }
})(jQuery);

define("vendor/jquery-emoji-picker/jquery.emojipicker", function(){});

